// extracted by mini-css-extract-plugin
export default {"container":"UserAccLayout_container__VNT7o","analys":"UserAccLayout_analys__TO-6+","period":"UserAccLayout_period__weJ+O","content":"UserAccLayout_content__SZSqM"};